export const filterOutCampaignAndAdgroupName = (scope, entitySchema) => {
  const entitySchemaCopy = entitySchema;
  if (scope.values.campaignId && entitySchemaCopy.properties.CampaignName) {
    entitySchemaCopy.properties.CampaignName.filterable = false;
  }
  if (scope.values.adGroupId && entitySchemaCopy.properties.AdGroupName) {
    entitySchemaCopy.properties.AdGroupName.filterable = false;
  }

  return entitySchemaCopy;
};
